import './PageLoader.css';

const PageLoader = ({ text = "Loading..." }) => (
  <div className="page-loader">
    <span className="spinner" />
    {/* <p>{text}</p> */}
  </div>
);

export default PageLoader;
